/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  Box,
  StackLayout,
  HeadingText,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { HtmlToReact } from '@leagueplatform/web-common';

interface AboutBodySectionProps {
  htmlString: string;
}

export const AboutBodySection: React.FC<AboutBodySectionProps> = ({
  htmlString,
}) => (
  <StackLayout
    orientation={{
      '@initial': 'horizontal',
      '@mobile': 'vertical',
    }}
    verticalAlignment="top"
    horizontalAlignment="center"
    css={{
      padding: '$one',
      '@mobile': { paddingBlock: '$one' },
    }}
  >
    <Box
      css={{
        '.GDS-heading-text, table': {
          marginBlockEnd: '$half',
        },
        table: {
          width: 'fit-content',
          '@mobile': {
            'a[href^="mailto"]': {
              wordBreak: 'break-word',
            },
          },
        },
      }}
    >
      <HtmlToReact
        htmlString={htmlString}
        options={{
          h3: {
            component: HeadingText as React.FunctionComponent,
            props: { level: '2', size: 'lg' },
          },
          h6: { component: HeadingText, props: { level: '6', size: 'xs' } },
          p: {
            component: ParagraphText as React.FunctionComponent,
            props: {
              'margin-bottom': '24px',
            },
          },
          ul: {
            component: ParagraphText as React.FunctionComponent,
            props: {
              as: 'ul',
              css: {
                listStyle: 'revert',
                paddingLeft: '$oneAndHalf',
                li: { typography: '$bodyOne' },
              },
            },
          },
        }}
      />
    </Box>
  </StackLayout>
);
